import { render } from "./DefaultPage.vue?vue&type=template&id=782323fc"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"

import "@/styles/global.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__